import userService from './user'

export default {
  namespaced:true,
  modules:{
    user: userService
  }
}
